import { render, staticRenderFns } from "./ManagementQuestions.vue?vue&type=template&id=5a1cb78f&scoped=true&"
import script from "./ManagementQuestions.vue?vue&type=script&lang=js&"
export * from "./ManagementQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ManagementQuestions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ManagementQuestions.vue?vue&type=style&index=1&id=5a1cb78f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1cb78f",
  null
  
)

export default component.exports